@if (isVisible()) {
  <div class="ui-drawer__layer">
    @if (closeOnBackdrop()) {
      <button
        type="button"
        class="ui-drawer__backdrop"
        aria-label="Cerrar"
        (click)="close()"
      ></button>
    } @else {
      <div class="ui-drawer__backdrop" aria-hidden="true"></div>
    }

    <aside
      [class]="'ui-drawer__panel ' + panelClass()"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="title()"
      [style.--ui-drawer-panel-width]="panelWidth() || null"
      [style.--ui-drawer-panel-height]="panelHeight() || null"
    >
      <header class="ui-drawer__header">
        <div class="ui-drawer__heading">
          <h2 class="ui-drawer__title">
            <span class="ui-drawer__title-default">{{ title() }}</span>
            @if (mobileTitle()) {
              <span class="ui-drawer__title-mobile">{{ mobileTitle() }}</span>
            }
          </h2>
          <ng-content select="[title-addon]" />
        </div>
        <div class="ui-drawer__actions">
          <ng-content select="[actions]" />
          <ui-button variant="secondary" [size]="effectiveActionsSize()" (pressed)="onCancel()">
            {{ cancelLabel() }}
          </ui-button>
          @if (showSaveButton()) {
            <ui-button variant="primary" [size]="effectiveActionsSize()" (pressed)="save()">
              {{ saveLabel() }}
            </ui-button>
          }
          <ng-content select="[actions-end]" />
        </div>
      </header>

      <div
        class="ui-drawer__body"
        [class.ui-drawer__body--fill]="fill()"
      >
        <ng-content />
      </div>
    </aside>
  </div>
}
